import React from "react";

function getTopPos(dataAttributeKey) {
  // we scroll to the filter block
  const filterBlock = document.getElementById(`filterBlock${dataAttributeKey}`);
  if (filterBlock === null) return null;

  let top = filterBlock.getBoundingClientRect().top;

  // we have to move up back to height of the header
  const header = document.getElementsByClassName("main__header")[0];
  top -= header.clientHeight;

  // we have to add the page offset for the right scroll top position
  top += window.pageYOffset;

  return top;
}

const ScrollToHOC = ({ dataAttributeKey, children }) => (
  <span onClick={() => window.scrollTo({ top: getTopPos(dataAttributeKey), behavior: "smooth" })}>{children}</span>
);

export default ScrollToHOC;
